'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchDataForCatalogSearchPage = exports.updateFacetsSelected = exports.updateSearchParams = exports.fetchCatalogsTodayCountIfNeeded = exports.fetchCatalogSearchResults = exports.getCatalogSearchDate = exports.getCatalogSearchPageSize = exports.getCatalogSearchPage = exports.getCatalogSearchParams = exports.getCatalogSearchSaleTypeFacets = exports.getCatalogSearchCountryFacets = exports.getCatalogSearchHouseFacets = exports.getCatalogSearchFacets = exports.getCatalogSearchSubmitted = exports.getCatalogSearchTotalCount = exports.getCatalogSearchIds = exports.getCatalogsTodayCount = exports.getUiCatalogSearch = exports.LOAD_CATALOGS_TODAY_COUNT_FAIL = exports.LOAD_CATALOGS_TODAY_COUNT_SUCCESS = exports.LOAD_CATALOGS_TODAY_COUNT_REQUEST = exports.UPDATE_FACETS_SELECTED = exports.UPDATE_CATALOG_SEARCH_PARAMS = exports.LOAD_CATALOG_SEARCH_SUCCESS = exports.LOAD_CATALOG_SEARCH_REQUEST = exports.LOAD_CATALOG_SEARCH_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _catalogAd = require('./catalogAd');

var _catalog = require('./catalog');

var _coverLots = require('./coverLots');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var prefix = 'la/ui/catalogSearch';
var LOAD_CATALOG_SEARCH_FAIL = exports.LOAD_CATALOG_SEARCH_FAIL = prefix + '/LOAD_FAIL';
var LOAD_CATALOG_SEARCH_REQUEST = exports.LOAD_CATALOG_SEARCH_REQUEST = prefix + '/LOAD_REQUEST';
var LOAD_CATALOG_SEARCH_SUCCESS = exports.LOAD_CATALOG_SEARCH_SUCCESS = prefix + '/LOAD_SUCCESS';
var UPDATE_CATALOG_SEARCH_PARAMS = exports.UPDATE_CATALOG_SEARCH_PARAMS = prefix + '/UPDATE_SEARCH_PARAMS';
var UPDATE_FACETS_SELECTED = exports.UPDATE_FACETS_SELECTED = prefix + '/UPDATE_FACETS_SELECTED';
var LOAD_CATALOGS_TODAY_COUNT_REQUEST = exports.LOAD_CATALOGS_TODAY_COUNT_REQUEST = prefix + '/LOAD_TODAY_REQUEST';
var LOAD_CATALOGS_TODAY_COUNT_SUCCESS = exports.LOAD_CATALOGS_TODAY_COUNT_SUCCESS = prefix + '/LOAD_TODAY_SUCCESS';
var LOAD_CATALOGS_TODAY_COUNT_FAIL = exports.LOAD_CATALOGS_TODAY_COUNT_FAIL = prefix + '/LOAD_TODAY_FAIL';

// reducer
var DEFAULT_STATE = {
    catalogIds: [],
    error: false,
    facets: [],
    searchParams: {
        page: 1,
        pageSize: 24
    },
    submitted: false,
    success: false,
    totalFound: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_CATALOG_SEARCH_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case LOAD_CATALOG_SEARCH_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case LOAD_CATALOG_SEARCH_SUCCESS:
            return (0, _extends3.default)({}, state, {
                catalogIds: action.payload.response.results.map(function (c) {
                    return c.catid;
                }),
                facets: action.payload.response.facets,
                submitted: false,
                success: true,
                totalFound: action.payload.response.count
            });
        case UPDATE_CATALOG_SEARCH_PARAMS:
            return (0, _extends3.default)({}, state, {
                searchParams: (0, _extends3.default)({}, action.payload)
            });
        case UPDATE_FACETS_SELECTED:
            return (0, _extends3.default)({}, state, {
                facets: action.payload.facets
            });
        case LOAD_CATALOGS_TODAY_COUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case LOAD_CATALOGS_TODAY_COUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                catalogsTodayCount: action.payload.count,
                submitted: false,
                success: true
            });
        case LOAD_CATALOGS_TODAY_COUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}
/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.catalogSearch;
};

var getUiCatalogSearch = exports.getUiCatalogSearch = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getCatalogsTodayCount = exports.getCatalogsTodayCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogsTodayCount;
});

var getCatalogSearchIds = exports.getCatalogSearchIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogIds;
});

var getCatalogSearchTotalCount = exports.getCatalogSearchTotalCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.totalFound;
});

var getCatalogSearchSubmitted = exports.getCatalogSearchSubmitted = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.submitted;
});

var getCatalogSearchFacets = exports.getCatalogSearchFacets = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.facets.length > 0 ? state.facets : [];
});

var getCatalogSearchHouseFacets = exports.getCatalogSearchHouseFacets = (0, _reselect.createSelector)(getCatalogSearchFacets, function (facets) {
    var facet = facets.find(function (x) {
        return x.id === 'house_id';
    });
    if (facet && facet.values && facet.values.length > 0) {
        return facet.values.sort(sortFacets);
    }
    return [];
});
var getCatalogSearchCountryFacets = exports.getCatalogSearchCountryFacets = (0, _reselect.createSelector)(getCatalogSearchFacets, function (facets) {
    var facet = facets.find(function (x) {
        return x.id === 'country';
    });
    if (facet && facet.values && facet.values.length > 0) {
        return facet.values.sort(sortFacets);
    }
    return [];
});
var getCatalogSearchSaleTypeFacets = exports.getCatalogSearchSaleTypeFacets = (0, _reselect.createSelector)(getCatalogSearchFacets, function (facets) {
    var facet = facets.find(function (x) {
        return x.id === 'sale_type';
    });
    if (facet && facet.values && facet.values.length > 0) {
        return facet.values.sort(sortFacets);
    }
    return [];
});

var sortFacets = function sortFacets(a, b) {
    if (a.selected === b.selected) {
        return b.count - a.count;
    }
    return b.selected ? 1 : -1;
};

var getCatalogSearchParams = exports.getCatalogSearchParams = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.searchParams;
});

var getCatalogSearchPage = exports.getCatalogSearchPage = (0, _reselect.createSelector)(getCatalogSearchParams, function (searchParams) {
    return searchParams.page;
});

var getCatalogSearchPageSize = exports.getCatalogSearchPageSize = (0, _reselect.createSelector)(getCatalogSearchParams, function (searchParams) {
    return searchParams.pageSize;
});

var getCatalogSearchDate = exports.getCatalogSearchDate = (0, _reselect.createSelector)(getCatalogSearchParams, function (searchParams) {
    return searchParams.date || '';
});

/* ACTIONS CREATORS */
var fetchCatalogSearchResults = exports.fetchCatalogSearchResults = function fetchCatalogSearchResults(params) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        var searchParams = getCatalogSearchParams(state);
        var parameters = (0, _extends3.default)({
            client: 'web',
            client_version: '5.0.0',
            max_facet_values: 3,
            pagesize: searchParams.pageSize || searchParams.pagesize
        }, searchParams, params);

        dispatch({
            type: LOAD_CATALOG_SEARCH_REQUEST
        });

        return _api.CatalogSearch.fetchResults({ deployment: deployment, searchParams: parameters }).then(function (response) {
            dispatch({
                payload: { response: response },
                type: LOAD_CATALOG_SEARCH_SUCCESS
            });
        }, function (error) {
            dispatch({
                error: true,
                payload: error,
                type: LOAD_CATALOG_SEARCH_FAIL
            });
        });
    };
};

var fetchCatalogsTodayCountIfNeeded = exports.fetchCatalogsTodayCountIfNeeded = function fetchCatalogsTodayCountIfNeeded() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, todayCount, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            todayCount = getCatalogsTodayCount(state);

                            if (todayCount) {
                                _context.next = 10;
                                break;
                            }

                            deployment = (0, _config.getDeployment)(state);


                            dispatch({
                                type: LOAD_CATALOGS_TODAY_COUNT_REQUEST
                            });
                            _context.next = 8;
                            return _api.CatalogSearch.fetchCatalogsTodayCount(deployment);

                        case 8:
                            response = _context.sent;

                            dispatch({
                                payload: response.data[0],
                                type: LOAD_CATALOGS_TODAY_COUNT_SUCCESS
                            });

                        case 10:
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                type: LOAD_CATALOGS_TODAY_COUNT_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var updateSearchParams = exports.updateSearchParams = function updateSearchParams(searchParams) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({
                                payload: searchParams,
                                type: UPDATE_CATALOG_SEARCH_PARAMS
                            });

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var updateFacetsSelected = exports.updateFacetsSelected = function updateFacetsSelected(searchParams) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, facets, searchParams;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            facets = getCatalogSearchFacets(state);
                            searchParams = getCatalogSearchParams(state);


                            dispatch({
                                payload: { facets: facets, searchParams: searchParams },
                                type: UPDATE_FACETS_SELECTED
                            });

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var fetchDataForCatalogSearchPage = exports.fetchDataForCatalogSearchPage = function fetchDataForCatalogSearchPage(searchQuery) {
    return function (dispatch, getState) {
        return _promise2.default.all([dispatch(fetchCatalogsTodayCountIfNeeded()), dispatch((0, _catalogAd.fetchCatalogAdIfNeeded)({ categoryIds: '0', pageName: 'calendar' }))] // pass 0 to indicate that its the calendar/catalog search page
        ).then(function () {
            return _promise2.default.all([dispatch(updateSearchParams(searchQuery)), dispatch(fetchCatalogSearchResults(searchQuery))]);
        })
        // in order to re-arrange the facets set in state we need to adjust them after the search call
        .then(function () {
            return _promise2.default.all([dispatch(updateFacetsSelected())]);
        }).then(function () {
            var state = getState();
            var catalogIds = getCatalogSearchIds(state);
            return _promise2.default.all([dispatch((0, _catalog.fetchCatalogsIfNeeded)(catalogIds)), dispatch((0, _coverLots.fetchCoverLotsIfNeeded)(catalogIds))]);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogSearch.js
// module id = D6G4
// module chunks = 60